import Management from "#/modules/management/Management";

export default Management;
